import * as confirmAction from "../../store/confirm/action";

import { Button, Modal } from "reactstrap";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";

const Confirm = () => {
  const dispatch = useDispatch();
  const confirmReducer = useSelector(state => state.Confirm);
  return (
    <>
      {
        <Modal
          isOpen={confirmReducer.show}
          scrollable={true}
          backdrop={"static"}
          centered={true}
        >
          <div className="modal-header">
            <h5 className="modal-title">{confirmReducer.title}</h5>
          </div>
          <div className="modal-body">
            <h5 className="mt-3">{confirmReducer.message}</h5>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                confirmReducer.confirm();
                dispatch(confirmAction.hideConfirm());
              }}
            >
              <i className="fas fa-check"></i>&nbsp; Confirm
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() =>dispatch(confirmAction.hideConfirm())}
            >
              <i className="fas fa-times"></i>
              &nbsp; Cancel
            </button>
          </div>
        </Modal>
      }
    </>
  );
};

export default Confirm;
